import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import ScrollToTop from "./components/ScrollToTop";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <Routes />
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
